import { Clock } from "lucide-react";
import { useContext } from "react";

import { LanguageContext } from "../languageContext";

const TimeNumberWithUnit = ({
  number,
  withColon,
  hasPrevNumber,
  type,
}: {
  number: number;
  withColon?: boolean;
  hasPrevNumber?: boolean;
  type: "hour" | "minute" | "second";
}) => {
  const { translate } = useContext(LanguageContext);
  if (!hasPrevNumber && (number === undefined || number === 0)) return null;

  const getNumber = (number: number) => {
    return number < 10 && hasPrevNumber ? `0${number}` : number;
  };
  return (
    <>
      <div className="sr-only">
        {number} {translate(`${type}${number !== 1 ? "s" : ""}`)}
      </div>
      <div aria-hidden="true" className="flex">
        <div>
          <div className="text-[18px]">{getNumber(number)}</div>
          <div className="flex justify-center mt-[-5px] text-sm">
            {translate(`${type}Abbreviation`)}
          </div>
        </div>
        {withColon && <>:</>}
      </div>
    </>
  );
};

export default function TimeLabel({
  hours,
  minutes,
  seconds,
}: {
  hours: number;
  minutes: number;
  seconds: number;
}) {
  const { translate } = useContext(LanguageContext);
  return (
    <div
      aria-label={`${hours} ${translate("hours")} ${minutes} ${translate(
        "minutes"
      )} ${seconds} ${translate("seconds")}`}
      className="flex font-mono items-center"
    >
      <Clock className="mr-3" size={18} />
      <TimeNumberWithUnit
        hasPrevNumber={false}
        number={hours}
        type="hour"
        withColon
      />
      <TimeNumberWithUnit
        hasPrevNumber={!!hours}
        number={minutes}
        type="minute"
        withColon
      />
      <TimeNumberWithUnit
        hasPrevNumber={minutes !== undefined}
        number={seconds}
        type="second"
      />
    </div>
  );
}
